import React from "react";
import { LoadingButton } from "@/components/LoadingButton";
import { cn } from "@/lib/utils";

interface MintTokenSubmitButtonProps
  extends React.HTMLAttributes<HTMLDivElement> {
  isLoading: boolean;
  buttonText: string; // e.g. "Mint Token & Create Liquidity Pool on Solana"
  onClick: () => void;
}

const MintTokenSubmitButton: React.FC<MintTokenSubmitButtonProps> = ({
  className,
  isLoading,
  buttonText,
  onClick,
  ...props
}) => {
  return (
    <div className={cn("flex justify-end", className)} {...props}>
      <LoadingButton onClick={onClick} loading={isLoading}>
        {buttonText}
      </LoadingButton>
    </div>
  );
};

export default MintTokenSubmitButton;
